import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import WelcomeHeader from 'pages/WelcomePage/components/WelcomeHeader/WelcomeHeader';
import { getProducts } from 'service/CatalogService';
import ProductCard from 'components/ProductCard/ProductCard';
import { Button } from 'components';
import styles from './CategoryProductsPage.module.scss';

export default function CategoryProductsPage({ embedded = false, embeddedCategoryId = null, onOpenProduct }) {
  const location = useLocation();
  const navigate = useNavigate();

  // Prefer embedded prop, then navigation state, then query param ?id=...
  const searchParams = new URLSearchParams(location.search || '');
  const categoryId = embedded ? embeddedCategoryId : (location.state?.id || searchParams.get('id'));

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [categoryName, setCategoryName] = useState('');

  useEffect(() => {
    if (!categoryId) return;
    let mounted = true;
    setLoading(true);
    getProducts({ page: 1, page_size: 50, category: categoryId })
      .then((r) => {
        if (!mounted) return;
        const data = r.data;
        setProducts((data && data.results) || data || []);
      })
      .catch(() => {})
      .finally(() => mounted && setLoading(false));
    return () => { mounted = false };
  }, [categoryId]);

  // fetch category name using categories list (no single category endpoint available)
  useEffect(() => {
    if (!categoryId) return;
    let mounted = true;
    import('service/CatalogService').then(({ getCategories }) => {
      getCategories()
        .then((res) => {
          if (!mounted) return;
          const cats = res.data || [];
          const found = cats.find((c) => c.id == categoryId || String(c.id) === String(categoryId));
          setCategoryName(found ? (found.name || found.title || '') : '');
        })
        .catch(() => {
          if (!mounted) setCategoryName('');
        });
    }).catch(() => {});
    return () => { mounted = false };
  }, [categoryId]);

  if (!categoryId) {
    return (
      <div>
        <WelcomeHeader />
        <div className={styles.container}>
          <div className={styles.empty}>Категория не выбрана</div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.title}>{categoryName || 'Товары категории'}</h2>
        </div>

        {loading ? <div>Загрузка...</div> : (
          <div className={styles.productsGrid}>
            {products.map(p => <ProductCard key={p.id} product={p} onOpen={onOpenProduct} />)}
          </div>
        )}
      </div>
    </div>
  );
}
